import { ISchema, ISchemaField, ISchemaHistoryResponse } from '_/types/schemas/schema.types';
import zeusSdk from '_/utils/SDKs';

// Backwards compatibility type aliases
export type Schema = ISchema;
export type SchemaField = ISchemaField;

export const fetchAllSchemas = async (): Promise<Schema[]> => {
  try {
    const options = {
      queryParameters: {
        sort: 'name',
        sortDirection: 'ASC',
      },
    };
    const schemas = await zeusSdk.schemas.listAll(options);
    return Array.isArray(schemas) ? schemas : [];
  } catch (error) {
    console.error('Error fetching schemas', error);
    return [];
  }
};

export const fetchSchemaBySlug = async (schemaSlug: string): Promise<Schema | null> => {
  try {
    const schema = await zeusSdk.schemas.get(schemaSlug);
    return schema;
  } catch (error) {
    console.error('Error fetching schema', error);
    return null;
  }
};

export const createSchema = async (schema: Partial<Schema>): Promise<Schema> => {
  return zeusSdk.schemas.create(schema);
};

export const updateSchema = async (schemaId: string, updates: Partial<Schema>): Promise<Schema> => {
  return zeusSdk.schemas.patch(schemaId, updates);
};

export const deleteSchema = async (schemaId: string): Promise<void> => {
  await zeusSdk.schemas.delete(schemaId);
};

export const fetchSchemaHistory = async (schemaId: string, cursor?: string, limit = 5): Promise<ISchemaHistoryResponse> => {
  try {
    const options = {
      queryParameters: {
        limit: limit,
        sortDirection: 'DESC',
        ...(cursor && { cursor: cursor }),
      },
    };
    const response = await zeusSdk.schemas.getChild(schemaId, '_versions', options);
    return {
      items: response.items || response,
      cursor: response.cursor,
    };
  } catch (error) {
    console.error('Error fetching schema history', error);
    return { items: [] };
  }
};
